import { render, staticRenderFns } from "./ModalSubmitOrder.vue?vue&type=template&id=3481e2e2&scoped=true&"
import script from "./ModalSubmitOrder.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubmitOrder.vue?vue&type=style&index=0&id=3481e2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481e2e2",
  null
  
)

export default component.exports